export const parseErrors = (err, errCb) => {
  const msg = err?.response?.data;
  if (msg) {
    errCb?.(msg);
  } else {
    errCb?.({ error: err?.name + ' ' + err?.message, type: 'ServerError' });
  }
};

export const getErrorDetails = (err, errCb) => {
  const data = err?.response?.data;
  let errorObj = {};
  if (Array.isArray(data?.details) && data.details.length > 0) {
    const details = [];
    data.details.forEach((detail) => {
      try {
        const parsed = typeof detail === 'string' ? JSON.parse(detail) : detail;
        if (parsed?.error) details.push(parsed.error);
      } catch {
        details.push(String(detail));
      }
    });
    errorObj = { error: details.length > 0 ? details.join('\n') : (data?.error ?? 'Произошла ошибка') };
  } else {
    const message = data?.error ?? data?.message ?? data?.detail ?? (typeof data === 'string' ? data : null);
    errorObj = { error: message ?? err?.message ?? 'Произошла ошибка' };
  }
  errCb?.(errorObj);
};
//
